module.exports = __webpack_public_path__ + "static/media/RS.18cd2ff7.png";